import { render, staticRenderFns } from "./Produtividade.vue?vue&type=template&id=b71b7632"
import script from "./Produtividade.vue?vue&type=script&lang=js"
export * from "./Produtividade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports